import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAoyA88R0eNA8G0sRSwOnyJsHMroGQDbwk",
  authDomain: "pumo-crm.firebaseapp.com",
  projectId: "pumo-crm",
  storageBucket: "pumo-crm.firebasestorage.app",
  messagingSenderId: "799232872715",
  appId: "1:799232872715:web:49a05c5ba6b4f88d3a920e",
  measurementId: "G-NBBX253T51"
};

const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);

